<template>
	<div class="preview-banner" :class="{ 'preview-banner--with-env-banner': props.hasEnvBanner }">
		<div class="preview-banner__title">{{ t('duty_change_preview') }}</div>

		<div class="preview-banner__stats">
			<span>{{ violations }} {{ t('title_violations') }}</span>
			<span>·</span>
			<span>{{ changes }} {{ t('changes') }}</span>
		</div>

		<div class="preview-banner__actions">
			<v-btn variant="text" class="preview-banner__cancel" @click="emit('cancel')"> {{ $t('cancel') }} </v-btn>

			<v-btn variant="text" class="preview-banner__publish" :disabled="changes === 0" @click="emit('publish')"> {{ t('presets.publish') }}</v-btn>
		</div>
	</div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

defineOptions({
	name: 'DutyChangePreviewBanner',
});

const { t } = useI18n();

interface Props {
	violations?: number;
	changes?: number;
	hasEnvBanner?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
	violations: 4,
	changes: 5,
	hasEnvBanner: false,
});

const emit = defineEmits<{
	cancel: [];
	publish: [];
}>();
</script>

<style scoped>
.preview-banner {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 62px;
	z-index: 1500;

	display: flex;
	align-items: center;
	padding: 0 34px;

	background: #fff3e0;
	border-bottom: 2px solid #ffcc80;
	color: #8b4513;
}
.preview-banner--with-env-banner {
	top: 25px;
}

.preview-banner__title {
	font-family: Roboto, sans-serif;
	font-weight: 400;
	font-size: 20px;
	line-height: 32px;
	letter-spacing: 0.25px;
	color: #7b3306;
}

.preview-banner__stats {
	position: absolute;
	left: 50%;
	transform: translateX(-50%);

	display: flex;
	align-items: center;
	gap: 10px;

	font-family: Roboto, sans-serif;
	font-weight: 500;
	font-size: 16px;
	line-height: 24px;

	color: #7b3306;
}

.preview-banner__actions {
	margin-left: auto;

	display: flex;
	align-items: center;
	gap: 16px;
}

.preview-banner__cancel {
	background-color: #f5f5f5;
	color: #000000de;
	border: 1px solid #0000001f;
}

.preview-banner__publish {
	background-color: #10565c;
	color: white;
}
</style>
